import { DataGridColSettings } from '@/components/DataGrid/utils';

export const masterPersonsDataGridCols: DataGridColSettings[] = [
  {
    field: 'uniqueId',
    headerName: 'ID',
    width: 120,
    visible: true,
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 280,
    visible: true,
  },
  {
    field: 'birthday',
    headerName: 'Date of Birth',
    width: 160,
    visible: true,
  },
  {
    field: 'address',
    headerName: 'Address',
    visible: true,
    width: 280,
  },
  {
    field: 'flags',
    headerName: 'Flags',
    visible: true,
    width: 150,
  },
  {
    field: 'phone',
    headerName: 'Phone number',
    width: 280,
    visible: true,
  },
  {
    field: 'licenseId',
    headerName: 'License ID',
    width: 180,
    visible: true,
  },
  {
    field: 'ethnicity',
    headerName: 'Ethnic Origin',
    width: 220,
    visible: true,
  },
  {
    field: 'race',
    headerName: 'Race',
    width: 180,
    visible: true,
  },
  {
    field: 'ssn',
    headerName: 'Social security number',
    width: 240,
    visible: true,
  },
  {
    field: 'lastUpdated',
    headerName: 'Last updated',
    width: 180,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 96,
    visible: true,
  },
];

export const maskSensitiveString = (
  value: string | undefined | null,
  n = 4,
): string => {
  if (!value || value.length < n) return '*'.repeat(value?.length || 0);
  return '*'.repeat(value.length - n) + value.slice(-n);
};

export const inmatePersonsDataGridCols: DataGridColSettings[] = [
  {
    field: 'lastName',
    headerName: 'Last Name',
    width: 360,
    visible: true,
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    visible: true,
  },
  {
    field: 'driverLicense',
    headerName: 'Driver License Number',
    width: 360,
    visible: true,
  },
  {
    field: 'ssn',
    headerName: 'Social security number',
    width: 360,
    visible: true,
  },
  {
    field: 'birthday',
    headerName: 'Date of birth',
    width: 360,
    visible: true,
  },
  {
    field: 'inmateId',
    headerName: 'Inmate ID',
    width: 340,
    visible: true,
  },
];
